module.controller('sendPhysicalCardCtrl', ['$scope', '$state', '$http', 'cacheService', 'Session', 'baseURI', 'Transform', 'STATES', 'OVERLAY', function($scope, $state, $http, cacheService, Session, baseURI, Transform, STATES, OVERLAY) {
  var subUrl = baseURI + 'card/sub-cards';
  var cardStatusUrl = baseURI + 'card/status';

  $scope.overlay = OVERLAY['member.home.send-physical-card'];
  $scope.noSidebar = true;
  $scope.states = STATES;
  $scope.formData = {};
  $scope.hasSubs = Session.getHasSubs();
  $scope.alert = {};
  $scope.alert.alertShown = false;
  $scope.alert.alertMessage = 'Sorry, we were unable to process your request at this time. If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';
  $scope.attempted = false;

  $scope.attemptSubmissionAndProcessForm = function(formObject, formData) {
    if(formObject.$valid){
      $scope.alert.errorShown = false;
      processForm(formData);
    } else {
      $scope.alert.errorShown = true;
      $scope.attempted = true;
    }
  };

  function processForm(formData){
    $scope.loading = true;
    formData.StateCode = formData.State.key;

    $http({
      method: 'PUT',
      url: baseURI + 'cardholder/profile',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(formData)
    }).then(function (resp){
      reissue();
    }).catch(function (error){
      $scope.alert.alertShown = true;
      $scope.loading = false;
    }).then(function(){
      $scope.loading = false;
    });
  }

  function reissue() {
    $http({
      method: 'PUT',
      url: baseURI + 'card/type',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode({
        NewCardType: 'card',
        Username: $state.params.username
      })
    }).then(function (resp){
      var data = resp.data;

      if(data.Success){
        cacheService.clear('subcard');
        cacheService.clear('feeds');
        cacheService.clear('card-type');
        $state.go('member.home.send-physical-card.confirmation');
      } else {
        $scope.alert.alertShown = true;
      }
    }).catch(function (error){
      $scope.alert.alertShown = true;
      $scope.loading = false;
    }).then(function(){
      $scope.loading = false;
    });
  }

}]);
